import { extend } from "vee-validate";
import { required, confirmed, is_not } from "vee-validate/dist/rules";

extend('required', required);
extend('confirmed', confirmed);
extend('is_not', is_not);


export const rules = {
    actual: {
        required: true
    },
    newp: {
        required: true,
        is_not: 'null'
    },
    repeat: {
        required: true,
        confirmed: 'vidnewp'
    },
    question: {
        required: true
    },
};